// src/pages/ForgotPasswordPage.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('Enviando...');
        try {
            const response = await fetch('https://kifli-api.onrender.com/api/forgot-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });
            const data = await response.json();
            setMessage(data.message);
        } catch (error) {
            setMessage('Error de conexión con el servidor.');
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="max-w-md w-full space-y-8 bg-[#292929] p-10 rounded-xl">
                <h2 className="text-center text-3xl font-bold text-white">Recuperar Contraseña</h2>
                <form onSubmit={handleSubmit} className="space-y-6">
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="input-field px-4" placeholder="Ingresa tu correo electrónico" />
                    <button type="submit" className="form-button bg-lime-400 text-black">Enviar Enlace</button>
                </form>
                {message && <p className="text-center text-white mt-4">{message}</p>}
                <div className="text-center">
                    <Link to="/ingresar" className="font-medium text-lime-400 hover:text-lime-300">Volver a Iniciar Sesión</Link>
                </div>
            </div>
        </div>
    );
}
export default ForgotPasswordPage;
